import VueCookies from 'vue-cookies'

export default {
    watch: {
        $route(to, _) {
            this.updateTitle(to)
        }
    },
    mounted() {
        this.updateTitle(this.$route)
    },
    methods: {
        updateTitle(route) {
            const identifier = VueCookies.get('user_type') // Replace 'identifier' with the name of your cookie
            let title = route && route.meta && route.meta.title ? route.meta.title : 'HMI Member\'s Portal'

            if (identifier === 'provider') {
                title = 'HMI Provider\'s Portal'
            } else if (identifier === 'member') {
                title = 'HMI Member\'s Portal'
            } else {
                title = 'HMI Portal'
            }

            document.title = title
        }
    }
}
